<template>
  <div class="wrapper daftarkan-masjid">
    <div class="donation-detail">
      <div
        class="main-content bg-white"
        style="padding: 15px; padding-bottom: 30px"
      >
        <div class="wrapper-form">
          <form @submit.prevent="handleRegister">
            <!-- INFORMASI PENGURUS -->
            <h3>Data Diri</h3>
            <SizedBox :height="60" />
            <div class="form-group">
              <label for="fullname"><strong>Nama Lengkap</strong></label>
              <p>{{ !fullname ? "Loading..." : fullname }}</p>
            </div>

            <SizedBox :height="15" />

            <!-- <div class="form-group">
              <label for="email"><strong>Email</strong></label>
              <p>{{ !email ? "Loading..." : email }}</p>
            </div>

            <SizedBox :height="15" /> -->

            <!-- <div class="form-group">
              <label for="no_telp"><strong>Nomor Telepon / HP</strong></label>
              <p>{{ !no_telp ? "Loading..." : no_telp }}</p>
            </div>

            <SizedBox :height="15" /> -->

            <div class="form-group">
              <label for="jeniskelamin"><strong>Jenis Kelamin</strong></label>
              <p>{{ !jeniskelamin ? "Loading..." : jeniskelamin }}</p>
            </div>

            <SizedBox :height="15" />
            <div class="form-group">
              <label for="tanggallahir"><strong>Tanggal Lahir</strong></label>
              <p>{{ !tanggallahir ? "Loading..." : tanggallahir }}</p>
            </div>
            <SizedBox :height="15" />

            <h3>Data Kependudukan</h3>
            <SizedBox :height="60" />

            <!-- <div class="form-group">
              <label for="nik"><strong>NIK ( Nomor Induk KTP )</strong></label>
              <p>{{ !nik ? "Loading..." : nik }}</p>
            </div>

            <SizedBox :height="15" /> -->

            <!-- <div class="form-group">
              <label for="nik"><strong>Foto KTP</strong></label>
              <div class="card">
                <div class="cekrek" v-if="!nik_url">
                  <img src="/img/cekrek.png" />
                </div>
                <div id="preview" class="preview">
                  <img v-if="nik_url" :src="nik_url" />
                </div>
              </div>
            </div>

            <SizedBox :height="15" /> -->

            <div class="form-group">
              <label for="provinsi"><strong>Provinsi</strong></label>
              <p>{{ !provinsi ? "Loading..." : provinsi }}</p>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kota"><strong>Kota</strong></label>
              <p>{{ !kota ? "Loading..." : kota }}</p>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="kecamatan"><strong>Kecamatan</strong></label>
              <p>{{ !kecamatan ? "Loading..." : kecamatan }}</p>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="masjed_address">
                <strong>Alamat Masjed </strong>
              </label>
              <p>{{ !alamat ? "Loading..." : alamat }}</p>
            </div>

            <SizedBox :height="35" />
            <a
              href="javascript:void(0)"
              class="btn btn-success btn-full"
              @click="backToGate"
            >
              <font-awesome-icon icon="home" /> Kembali
            </a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/FixedTopbar.vue";
import SizedBox from "@/components/SizedBox.vue";
import { required, email } from "vuelidate/lib/validators";
import axios from "@/utils/masjedapi";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Select2 from "v-select2-component";

export default {
  name: "donation-detail",
  components: {
    TopBar,
    SizedBox,
    DatePicker,
    Select2,
  },
  data() {
    return {
      isSubmit: false,

      id: "",

      fullname: "",
      email: "",
      no_telp: "",
      tanggallahir: "",
      jeniskelamin: "",
      pendidikan: "",
      agama: "",
      provinsi: "",
      kota: "",
      kecamatan: "",
      alamat: "",

      nik: "",
      nik_url: null,
      nik_file: null,

      // Maps
      center: { lat: 45.508, lng: -73.587 },
      zoom: 17,
      markers: [],
      currentPlace: null,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
      },

      reff_code: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);

    this.reff_code = this.$route.params.ref_code;
    this.id = this.$route.params.id;
    this.fetchOne();
  },
  methods: {
    backToGate() {
      this.$router.push({
        name: "akusisi-user-report-relawan",
        params: { ref_code: this.reff_code },
      });
    },
    fetchOne() {
      const self = this;
      axios.get(`/akusisi/relawan/${this.id}`).then((response) => {
        const { data } = response.data;
        console.log(data);

        self.fullname = data.fullname;
        self.email = data.email;
        self.no_telp = data.no_hp;
        self.tanggallahir = data.tgl_lahir;
        self.jeniskelamin =
          data.jenis_kelamin == "L" ? "Laki-laki" : "Perempuan";
        self.agama = "";
        self.provinsi = data.provinsi ? data.provinsi.name : "( kosong )";
        self.kota = data.kota ? data.kota.name : "( kosong )";
        self.kecamatan = data.kecamatan ? data.kecamatan.name : "( kosong )";
        self.alamat = data.alamat || "( kosong )";

        self.nik = data.no_ktp ? data.no_ktp : "( kosong )";
        self.nik_url = data.ktp ? `${self.hostImage}${data.ktp.path}` : "";
      });
    },
  },
  directives: {
    numberOnly: {
      bind: function(el) {
        el.handler = function() {
          el.value = el.value.replace(/\D+/, "");
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function(el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);
}

.wrapper-form {
  position: relative;
  h3 {
    position: absolute;
    font-size: 17px;
    margin: 0px;
    left: -15px;
    background: transparent linear-gradient(180deg, #28a745 0%, #145423 100%) 0%
      0% no-repeat padding-box;
    padding: 5px 40px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}

.error {
  font-size: 11px;
  color: rgb(255, 13, 13);
}
</style>
